import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { UserData } from './lms-header-common.model';

@Injectable({
  providedIn: 'root',
})
export class LmsHeaderCommonService {
  public breadCrumLabel = new BehaviorSubject('');
  public readonly loggedUserData = new BehaviorSubject({});
  private readonly showButtonSubject = new BehaviorSubject<boolean>(false);
  constructor(private readonly httpClient: HttpClient) {}

  getLoggedUser(): Observable<UserData> {
    const url = `${environment.baseUrl}${environment.getUserbyID}`;
    return this.httpClient.get<UserData>(url);
  }

  setbreadCrumLable(data: string) {
    this.breadCrumLabel.next(data);
  }

  getbreadCrumLable(): Observable<string> {
    return this.breadCrumLabel.asObservable();
  }

  setShowButton(value: boolean): void {
    this.showButtonSubject.next(value);
  }

  getShowButton(): Observable<boolean> {
    return this.showButtonSubject.asObservable();
  }

  setLoggedInUserData(data: any): void{
    this.loggedUserData.next(data);
  }

  getLoggedInUserData(): Observable<any>{
    return this.loggedUserData.asObservable();
  }
}
